import { computed, ref } from 'vue'
import { useLastCallStore } from '../stores/lastCall'
import { localDayKey } from '../utils/localDay'

const SNOOZE_KEY = 'dc.lastCall.snoozeDay'

function readStorage(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

function writeStorage(storage: Storage, key: string, value: string): void {
  try {
    storage.setItem(key, value)
  } catch {
    /* private mode */
  }
}

if (import.meta.env.DEV && typeof localStorage !== 'undefined') {
  try {
    localStorage.removeItem(SNOOZE_KEY)
  } catch {
    /* private mode */
  }
}

const snoozeDay = ref<string | null>(
  import.meta.env.DEV || typeof localStorage === 'undefined'
    ? null
    : readStorage(localStorage, SNOOZE_KEY),
)

/** Event explainer. Hidden once the track is finished, or after today's snooze. */
export function useLastCallNotice() {
  const lastCall = useLastCallStore()
  const finished = computed(
    () => lastCall.packGranted || lastCall.played >= lastCall.packAt,
  )
  const offerDialog = computed(
    () =>
      lastCall.open &&
      !finished.value &&
      snoozeDay.value !== localDayKey(),
  )

  function snoozeToday(): void {
    const day = localDayKey()
    snoozeDay.value = day
    writeStorage(localStorage, SNOOZE_KEY, day)
  }

  return { offerDialog, finished, snoozeToday }
}
